import { OpenFeature } from '@openfeature/web-sdk'
import { useRuntimeConfig } from '#app'

export async function getConfigStorePath(
  configStoreKey: string
): Promise<string> {
  const {
    app: { cdnURL = '' },
  } = useRuntimeConfig()
  const openfeature = OpenFeature.getClient()
  const value = await openfeature.getStringValue(configStoreKey, 'control')
  return `${cdnURL}/configs/${configStoreKey}/${value}.json`
}
